import React from 'react';
import styled from 'styled-components';
import { opportunities } from '@amzn/storm-ui-icons';
import { Icon } from '@amzn/storm-ui';

const StyledWrapper = styled('span')`
  position: relative;
`;

export function SalesAssistantIcon() {
  return (
    <StyledWrapper>
      <Icon type={opportunities} />
    </StyledWrapper>
  );
}
